module.exports = __webpack_public_path__ + "img/no-image.fd7f871b.png";